import { createSelector } from 'reselect';

import { createKeySelector } from 'Lib/reduxUtils';

export const selectSMS = createKeySelector('sms');

export const getPostPhoneNumberError = createSelector(
  selectSMS,
  (sms) => sms.postPhoneNumberError ?? null
);

export const getValidateSMSCodeError = createSelector(
  selectSMS,
  (sms) => sms.validateSmsCodeError ?? null
);

export const getPhoneNumber = createSelector(selectSMS, (sms) => sms.phoneNumber ?? '');

export const getPostPhoneNumberState = createSelector(selectSMS, (sms) => sms.postPhoneNumberState);

export const getValidateSMSCodeState = createSelector(selectSMS, (sms) => sms.validateSmsCodeState);

export const getOtpLength = createSelector(selectSMS, (sms) => sms.otpLength);

export const getSMSAuthState = createSelector(selectSMS, (sms) => sms.smsAuthState);

export const getSMSCaptchaReferenceToken = createSelector(
  selectSMS,
  (sms) => sms.smsCaptchaReferenceToken
);

export const getSmsSent = createSelector(selectSMS, (sms) => sms.smsSent);
